export default __webpack_public_path__ + "src/images/packages/marataba-conservation-camps/d1d16db88b607274a01f6746081f71c6-3.jpg";